module.exports = __webpack_public_path__ + "static/media/mock-medicinafetal1.b6f71313.png";